import { createContext, PropsWithChildren, useState } from 'react';

type CollapsibleContext = {
  active: string[];
  toggle(active: string): void;
};

type CollapsibleRoot = PropsWithChildren<{
  defaultOpened?: string;
}>;

export const CollapsibleContext = createContext<CollapsibleContext>(
  {} as CollapsibleContext
);

export function Root({ children, defaultOpened }: CollapsibleRoot) {
  const [active, setActive] = useState<string[]>(
    defaultOpened ? [defaultOpened] : []
  );

  const handleToggle = (value: string) => {
    const included = active.includes(value);

    if (included) {
      const updated = active.filter(v => v !== value);

      setActive([...updated]);

      return;
    }

    setActive([...active, value]);
  };

  return (
    <CollapsibleContext.Provider
      value={{
        active,
        toggle: handleToggle
      }}>
      <div className="flex flex-col gap-px">{children}</div>
    </CollapsibleContext.Provider>
  );
}
